module.exports = __webpack_public_path__ + "img/transaction-process1.fe2601cf.png";